export default "__VITE_ASSET__BpcHVGc9__"